import React from "react";
import "./home.css";
import "./About.css";
const AboutPage = () => {
return ( <div className="about-container">
{/* メインタイトル */} <h1>🌳 このサイトについて</h1>


  {/* リード文 */}
  <p className="lead">
    ストーリーを「育てる」場所へ。 <br />
    このサイトは、ひとつの物語（スレッド）を <br />
    ユーザー同士で成長させていくストーリー創作プラットフォームです。
  </p>

  {/* スレッドとノードの仕組み */}
  <section>
    <h2>🧩 スレッドとノードの仕組み</h2>
    <p>
      物語は「スレッド（Thread）」を中心に構成されています。<br />
      1つのスレッドの中に多くの選択肢を皆さんに投稿していただきます。<br />
      それぞれが物語の一部（分岐・文章・アイデア）を表します。<br />
      注意が必要なのは、コメント欄と選択肢の違いです。<br />
      選択肢は物語の進行に直接影響を与えますが、コメント欄はあくまで意見交換の場です。
    </p>

    <ul>
      <li>
        <strong>スレッド（Thread）</strong>：物語全体の単位。新規作成ページより作成できます。<br />
        タイトル・カテゴリ・投票設定・パスワード設定など。<br />
        個々のスレッドには独自の設定があり、物語の進行方法や参加ルールを決定します。
      </li>
      <li>
        <strong>選択肢</strong>：個々の投稿。<br />
        右側にある青いサイドバーに入力できます。<br />
        選択肢内容・作成者・投票数などが記録され、他のノードから分岐して物語を枝分かれさせることができます。
      </li>
      <li>
        <strong>コメント</strong>：交流の場。<br />
        スレッド下部にある入力欄より記入できます。<br />
        次の選択肢はどのようなものがいいかなど意見交換を行う場所です。<br />
        物語の進行には影響しません。
      </li>
    </ul>
  </section>

  {/* 再開機能 */}
  <section>
    <h2>🔁 再開機能</h2>
    <p>
      他の誰かが既存の物語を途中から再開し、新しいスレッドとして発展させることができます。
    </p>
    <ol>
      <li>図書館ページの該当のマインドマップへアクセスし気になる選択肢を選択。</li>
      <li>
        「このノードから再開」ボタンを押すと、そのノードの情報（タイトル・カテゴリ・設定など）が自動的に引き継がれます。
      </li>
      <li>
        <code>新規作成</code> ページで再開スレッドのタイトルや内容を入力し、新しい物語として公開。
      </li>
    </ol>
    <p>
      サイト上で元のストーリーの情報が記録され、再開した場合は分岐ストーリーとして元の物語と関連付けられます。<br />
      そしてまた新たなマインドマップが生成され、物語の広がりを視覚的に確認できます。
    </p>
  </section>

  {/* 投票と進行方式 */}
  <section>
    <h2>🗳️ 投票と進行方式</h2>
    <p>スレッドには3種類の選択肢を選ぶモードがあります：</p>
    <table className="mode-table">
      <thead>
        <tr>
          <th>モード</th>
          <th>説明</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>author</td>
          <td>作者のみが選択肢を選び物語を進行できます。</td>
        </tr>
        <tr>
          <td>vote</td>
          <td>ユーザー投票により、最も支持を得た選択肢が採用されます。</td>
        </tr>
        <tr>
          <td>timed</td>
          <td>時間制の投票形式で、一定時間後に投票が締め切られます。</td>
        </tr>
      </tbody>
    </table>
    <p>
      スレッド作成者はスレッド内で投票方法や投票時間を変更することができます。<br />
      他のユーザーは閲覧のみ可能です。
    </p>
  </section>

  {/* コメントと交流 */}
  <section>
    <h2>💬 コメントと交流</h2>
    <p>
      各スレッドにはコメント欄があり、物語に対する感想や提案を自由に投稿できます。<br />
      コメントはリアルタイムで反映され、ユーザー同士が物語の方向性を共有できます。
    </p>
  </section>

  {/* サイトの目的 */}
  <section>
    <h2>🌱 このサイトの目的</h2>
    <p>
      このサイトは「ひとつの物語を、複数の視点で育てる」ことを目的としています。<br />
      作者一人では見えなかった展開、他のユーザーの感性が紡ぐ分岐――<br />
      それらを自然な形でつなぎ合わせ、世界にひとつだけの物語を共同で作り上げていく。<br />
      そんな創作体験を、シンプルなUIと柔軟な構造で支援します。
    </p>
  </section>

  {/* まとめ */}
  <section>
    <h2>📘 まとめ</h2>
    <p>
      物語を読むだけでなく、分岐させて新しい展開を作る。それがこのサイトの核となる体験です。
    </p>
  </section>

  {/* アフィリエイトリンクについて */}
  <section>
    <h2>💰 アフィリエイトリンクについて</h2>
    <p>
      当サイトでは、Amazonアソシエイト・プログラムなどのアフィリエイトプログラムを利用しています。<br />
      紹介された商品をユーザーが購入した場合に、当サイトが報酬を受け取る仕組みです。
    </p>
    <p>
      商品情報や価格は記事作成時点のものであり、最新情報については各販売サイトをご確認ください。<br />
      アフィリエイト報酬はサイト運営や改善のために活用しています。
    </p>
  </section>
</div>

);
};

export default AboutPage;
